// extracted by mini-css-extract-plugin
export default {"wrapper":"feed-order-info_wrapper__zfcHn","container":"feed-order-info_container__uiqEe"};